import React from 'react';

import { getLanguage } from 'common/utils';

import Login from './Login';
import RecoverPassword from './RecoverPassword';
import Registration from './Registration';

const SignInPage = () => {
  const lang = getLanguage();

  return (
    <div className="login-layout blur-login" style={{height: '1000px'}}>
      <div className="main-container">
			  <div className="main-content">
				  <div className="row">
            <div className="col-sm-10 col-sm-offset-1">
              <div className="login-container">
                <div className="center">
                  <h1>
                    <i className="ace-icon fa fa-question green"></i>
                    <span className="red">&nbsp;App&nbsp;</span>
                    <span className="white" id="id-text2">iQuestion</span>
                  </h1>
								  <h4 className="blue" id="id-company-text">&copy; Batvina</h4>
							  </div>

                <div className="space-6"></div>

                <div className="position-relative">
                  <Login lang={lang} />
                  <RecoverPassword lang={lang} />
                  <Registration lang={lang} />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SignInPage;
